import { RouterManager } from '@aclass/admin/managers';
import { UserStory } from '@aclass/admin/storage/actions';
import { IAdminState, IUserModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class UserSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:user-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IUserModuleState['searchPageInitialized']>(['userModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(UserSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(UserStory.dryRunSearchPage());
    }
}
